module.exports = __webpack_public_path__ + "afb4a8b9570bbeae4b9e124ab5a933d4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fam/mainstay.png
// module id = 1814
// module chunks = 0